import {
  isCountry,
  isDepartment,
  isDistrict,
  isLandmark,
  isNamedPlace,
  isRegion,
  isTown
} from '../../../store/address/address.helpers'
import { geocodeForwardCtx } from '../../../store/search/search.service.constants'
import { slugify } from '../../../utils/string'
import { getSeoCityPostcode } from '../../seo/seo'

export const getImagePath = address => {
  const path = '/front-services/map/'

  const {
    name,
    postcode,
    town,
    named_place,
    countryLabel,
    countryCode,
    regionLabel,
    regionCode,
    departmentLabel,
    departmentCode
  } = address

  if (isCountry(address)) {
    const slug = `${countryCode}-${slugify(countryLabel)}`
    return `${path}country/${slug}`
  } else if (isRegion(address)) {
    const slug = `${regionCode}-${slugify(regionLabel)}`
    return `${path}region/${slug}`
  } else if (isDepartment(address)) {
    const slug = `${departmentCode}-${slugify(departmentLabel)}`
    return `${path}departement/${slug}`
  } else if (postcode) {
    if (isTown(address)) {
      const slug = `${slugify(getSeoCityPostcode(postcode), false)}-${slugify(town)}`
      return `${path}${slug}`
    } else if (isDistrict(address)) {
      const slug = `${slugify(postcode, false)}-${slugify(town)}`
      return `${path}${slug}`
    } else if (isNamedPlace(address)) {
      const slug = `${slugify(postcode, false)}-${slugify(named_place)}`
      return `${path}${slug}?filter=${geocodeForwardCtx.filter.hamlet}`
    } else if (isLandmark(address)) {
      const slug = `${slugify(postcode, false)}-${slugify(name)}`
      return `${path}${slug}?filter=${geocodeForwardCtx.filter.landmark}`
    }
  }
}
